import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Intent } from '@blueprintjs/core';

import NewCustomerForm from './NewCustomerForm';

class CustomerList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      customers: null,
    }

    this.receiveDataListener = this.receiveDataListener.bind(this);
    this.renderCustomerListRows = this.renderCustomerListRows.bind(this);
    this.removeCustomer = this.removeCustomer.bind(this);
  }

  componentWillMount() {
    this.props.route.database.ref('customers').on('value', this.receiveDataListener);
  }

  componentWillUnmount() {
    this.props.route.database.ref('customers').off('value', this.receiveDataListener);
  }

  receiveDataListener(snap) {
    this.setState({ customers: snap.val() });
  }

  removeCustomer(id) {
    this.props.route.database.ref(`customers/${id}`).remove();
  }

  renderCustomerListRows() {
    const rows = [];
    for (let key in this.state.customers) {
      if (!this.state.customers.hasOwnProperty(key)) continue;

      const customerData = this.state.customers[key];
      rows.push(
        <tr key={`customerListRow_${key}`}>
          <td>{key}</td>
          <td>{customerData.name}</td>
          <td>{customerData.loginCode}</td>
          <td><Button><Link to={`/customers/${key}`}>anzeigen</Link></Button></td>
          <td><Button iconName="delete" intent={Intent.DANGER} onClick={() => this.removeCustomer(key)} /></td>
        </tr>
      );
    }
    return rows;
  }

  render() {
    return (
      <div>
        <NewCustomerForm database={this.props.route.database} />
        <div className="pt-card">
          <h2>Kunden:</h2>
          <table>
            <thead>
              <tr>
                <th>id</th>
                <th>Name</th>
                <th>loginCode</th>
                <th>Details</th>
                <th>Löschen</th>
              </tr>
            </thead>
            <tbody>
              {this.renderCustomerListRows()}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default CustomerList;



/** WEBPACK FOOTER **
 ** ./src/CustomerList.js
 **/